import { Button, Text, TextInput, Select, Textarea } from "@mantine/core";
import React from "react";
import { useFormRender } from "../hooks/useFormRender";
import { addFormSchema } from "../schema/form/user";
import { useTranslation } from "react-i18next";

const UserEditButton = ({ mainForm }) => {
  let formSchema = { ...addFormSchema };
  formSchema.title = "Edit User Details";
  const { t } = useTranslation();

  const onSubmit = async ({ values, formMode }) => {
    try {
      mainForm.setValues(values);
      await formAction.updateAndSave(values);
    } catch (e) {
      console.log("UserEditButton error", e);
    }
  };

  const onSubmitSuccess = () => {
    formAction.close();
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    onSubmitSuccess,
    onSubmit
  );

  const handleActionClick = () => {
    const id = mainForm?.values._id;
    if (!id) return;
    formAction.open({ mode: "edit", id, data: mainForm.values });
  };

  return (
    <>
      {/* {JSON.stringify(mainForm.values.termination)} */}
      <Button
        fullWidth
        onClick={handleActionClick}
        variant="light"
        color="gray"
      >
        {t("Edit Details")}
      </Button>
      {renderForm()}
    </>
  );
};

export default UserEditButton;
